export default defineAppConfig({
  ui: {
    primary: 'rose',
    gray: 'zinc',
  },
})
